import { Card, FormControl, Grid,Radio, Typography, styled } from '@mui/material';

import styles from "../devoteeService.module.scss"
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ChangeEvent, useState } from 'react';
import { ValidationError, object, string } from 'yup';
import { isEmpty } from 'lodash';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import GridTableComponent from '../../common/GridTableComponent/gridTableTemplate';
import { CommonButton, CustomCalendarTodayOutlinedIcon, CustomDatePicker, CustomDeleteIcon, CustomMenuItem, CustomRequiredInputLabel, CustomSelect, CustomTextFeild, StyledDateContainer } from '../../common/StyledComponents/StyledFields';

interface ErrorMessageTypes {
    dob: string;
    preferedLanguage: string;
    nakshatram: string;
    gothram: string;
    access: string;
    dateOfRegistration: string;
    updateDate: string;
    categorie: string;
}
const CustomRadioButton = styled(Radio)`
  & svg {
    color: #F05802;
    height: 24px;
    width:24px;
  }
`;

const Categories = () => {
    const [formData, setFormData] = useState({
        dob: "",
        preferedLanguage: "",
        nakshatram: "",
        gothram: "",
        access: "",
        dateOfRegistration: "",
        updateDate: "",
        categorie: "",
    })
    const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
        dob: "",
        preferedLanguage: "",
        nakshatram: "",
        gothram: "",
        access: "",
        dateOfRegistration: "",
        updateDate: "",
        categorie: "",
    })
    const validationSchema = object().shape({
        dob: string().required('DOB is required'),
        preferedLanguage: string().required('Prefered Language is required'),
        nakshatram: string().required('Nakshatra is required'),
        gothram: string().required('Gothram is required'),
        access: string().required('Access is required'),
        dateOfRegistration: string().required('Date Of Registration is required'),
        updateDate: string().required("UpdateDate is required"),
        categorie: string().required('Categorie is required'),
    })
    const handleAdd = async () => {
        const errors: ErrorMessageTypes = {
            dob: "",
            preferedLanguage: "",
            nakshatram: "",
            gothram: "",
            access: "",
            dateOfRegistration: "",
            updateDate: "",
            categorie: "",
        }
        try {
            // Validate the form data against the validation schema
            await validationSchema.validate(formData, { abortEarly: false });
            // If validation passes, you can submit the form
            setErrorMessage(errors);
            alert('Data is Here');

            // Call your API or perform other actions here
            //  saveApiCall();

        } catch (error) {
            // Handle validation errors

            if (error instanceof ValidationError) {
                error.inner.forEach((e) => {
                    if (e.path) {
                        errors[e.path as keyof ErrorMessageTypes] = e.message;
                    }
                });
            }
            setErrorMessage(errors);
        }
    }
    const handleFieldChange = (field: string, value: any) => {
        setFormData({
            ...formData,
            [field]: value,
        });
    };
    const categoriesList = [
        {
            label: "option1",
        },
        {
            label: "option2",
        },
        {
            label: "option3",
        },
        {
            label: "option4",
        },
        {
            label: "option5",
        }
    ]

    const preferedLanguageList = [
        {
           language: 'Telugu',
        },
        {
           language: 'Hindi',
        },
        {
           language: 'English',
        },
        {
           language: 'Tamil',
        },
     ];

     const sortedLanguageList = preferedLanguageList.slice().sort((a, b) =>
     a.language.localeCompare(b.language)
   );

     const prefferedLanguageDropdown = (): React.ReactElement => {
        return (
           <FormControl sx={{width:"100%",}}>
              <CustomSelect 
              sx={{ border:"1px solid rgba(136, 46, 20, 0.40)",borderRadius:"8px"}}
                 IconComponent={KeyboardArrowDownIcon}
                 defaultValue=""
                 id="grouped-select"
                 value={formData.preferedLanguage}
                 onChange={(e) => handleFieldChange('preferedlanguage', e.target.value)}
                 MenuProps={{
                    PaperProps: {
                       sx: {
                          border: '1px solid #F05802',
                          '& ul': {
                             paddingTop: 0,
                             paddingBottom: 0,
                             overflowY: 'auto',
                             minHeight: 'auto',
                             maxHeight: '300px',
                             '&::-webkit-scrollbar': {
                                width: '8px',
                             },
                             '&::-webkit-scrollbar-thumb': {
                                background: '#F3C539',
                                borderRadius: '6px',
                             },
                          },
                       },
                    },
                 }}
                 className={errorMessage.preferedLanguage ? styles.errorTextField : styles.dropdownStyle}
              >
                 {sortedLanguageList.map((item, index) => (
                    <CustomMenuItem key={index} value={item.language}>
                       {item.language}
                    </CustomMenuItem>
                 ))}
              </CustomSelect>
              {!isEmpty(errorMessage.preferedLanguage) && (
                 <Typography sx={{ color: 'red', fontSize: '12px' }}>
                    {errorMessage.preferedLanguage}
                 </Typography>
              )}
           </FormControl>
        );
     };
  
    const CategoryDropdown = (): React.ReactElement => {
        return (
            <FormControl className={styles.dropDowns}>
                <CustomSelect
                    IconComponent={KeyboardArrowDownIcon}
                    defaultValue=""
                    id="grouped-select"
                    placeholder='Select categorie'
                    value={formData.categorie}
                    onChange={(e) => {
                        handleFieldChange('categorie', e.target.value);
                        setErrorMessage({ ...errorMessage, categorie: "" })
                    }}
                    MenuProps={{
                        PaperProps: {
                           sx: {
                              border: '1px solid #F05802',
                              '& ul': {
                                 paddingTop: 0,
                                 paddingBottom: 0,
                                 overflowY: 'auto',
                                 minHeight: 'auto',
                                 maxHeight: '300px',
                                 '&::-webkit-scrollbar': {
                                    width: '8px',
                                 },
                                 '&::-webkit-scrollbar-thumb': {
                                    background: '#F3C539',
                                    borderRadius: '6px',
                                 },
                              },
                           },
                        },
                     }}
                    className={errorMessage.categorie ? styles.errorTextField : styles.textField}>
                    {categoriesList.map((item, index) => (
                        <CustomMenuItem key={index} value={item.label}>
                            {item.label}
                        </CustomMenuItem>
                    ))}
                </CustomSelect>
                {errorMessage.categorie ? <Typography sx={{ color: "red", fontSize: "12px" }}>{errorMessage.categorie}</Typography> : ''}
            </FormControl>
        )
    }
    const BasicDatePicker = (): React.ReactElement => {
        return (
           <div style={{ minWidth: '100%', borderRadius: "8px" }}>
              <StyledDateContainer
                 sx={{ backgroundColor: '#FFF9E4', borderRadius: '8px', height: '48px' }}
              >
                 <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DateTimePicker']}>
                       <CustomDatePicker
                          slots={{
                             openPickerIcon: CustomCalendarTodayOutlinedIcon,
                          }}
                          slotProps={{
                             inputAdornment: {
                                position: 'end',
                             },
                          }}
                          format="MM-DD-YYYY"
                          value={
                             formData.dob ? dayjs(formData.dob, 'MM-DD-YYYY') : ''
                          }
                          onChange={(value) => {
                             setErrorMessage({ ...errorMessage, dob: '' });
                             handleFieldChange('dateOfBirth', value);
                          }}
                          className={errorMessage.categorie ? styles.errorTextField : styles.textField}
                       />
                    </DemoContainer>
                 </LocalizationProvider>
                 {errorMessage.dob ? (
                    <Typography sx={{ color: 'red', fontSize: '12px' }}>
                       {errorMessage.dob}
                    </Typography>
                 ) : (
                    ''
                 )}
              </StyledDateContainer>
           </div>
        );
     };
    const ItemAddedData = [
        {
            Default: (
                <div>
                    <CustomRadioButton />
                </div>
            ),
            Categorie: "chairman",
            Action: (
                <div>
                    <CustomDeleteIcon />
                </div>
            ),
        },
        {
            Default: (
                <div>
                    <CustomRadioButton />
                </div>
            ),
            Categorie: "Priest",
            Action: (
                <div>
                    <CustomDeleteIcon />
                </div>
            ),
        },
    ]

    const columnMapping = {
        Categorie: "Categorie",
     };
    return (
        <div>
            <div style={{ display: "flex" }}>
                {/* <LeftMainNavigation /> */}
                <div className={styles.CategoriesContainer}>
                    <Typography component="div" className={styles.typoGraphyHeading}>
                        Devotee Service
                    </Typography>
                    <div className={styles.formContainer}>
                        <Typography component="div" className={styles.typoGraphy}>
                            Categories
                        </Typography>
                        <Typography className={styles.typography}>
                            Manager Manager<br />
                            1232 ARROWHEAD AVE.LIVERMORE<br />
                            CALIFORNIA-94551<br />
                            Home Phone: -Work Phone:-<br />
                        </Typography>
                        <Card className={styles.cardContainer}>
                            <div style={{ padding: "24px" }}>
                                <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                                    <Grid xs={12} sm={3} item>
                                    {CustomRequiredInputLabel("Date Of Birth", true)}
                                    {BasicDatePicker()}

                                    </Grid>
                                    <Grid xs={12} sm={3} item>
                                    {CustomRequiredInputLabel("Preffered Language", true)}
                                        {prefferedLanguageDropdown()}

                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                                    <Grid xs={12} sm={3} item>
                                    {CustomRequiredInputLabel("Nakshatram", true)}
                                        <CustomTextFeild
                                            fullWidth
                                            required
                                            onChange={(e) => {
                                                handleFieldChange("nakshatram", e.target.value);
                                                setErrorMessage({ ...errorMessage, nakshatram: '' })
                                            }}
                                            className={errorMessage.nakshatram ? styles.errorTextField : styles.textField}
                                            placeholder="Enter Nakshatram"
                                        />
                                        {errorMessage.nakshatram ? <Typography sx={{ color: "red", fontSize: "12px" }}>{errorMessage.nakshatram}</Typography> : ''}
                                    </Grid>
                                    <Grid xs={12} sm={3} item>
                                    {CustomRequiredInputLabel("Gothram", true)}
                                        <CustomTextFeild
                                            fullWidth
                                            required
                                            onChange={(e) => {
                                                handleFieldChange("gothram", e.target.value);
                                                setErrorMessage({ ...errorMessage, gothram: '' })
                                            }}
                                            className={errorMessage.gothram ? styles.errorTextField : styles.textField}
                                            placeholder="Enter Gothram"
                                        />
                                        {errorMessage.gothram ? <Typography sx={{ color: "red", fontSize: "12px" }}>{errorMessage.gothram}</Typography> : ''}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                                    <Grid xs={12} sm={3} item>
                                    {CustomRequiredInputLabel("Access", true)}
                                        <CustomTextFeild
                                            fullWidth
                                            required
                                            onChange={(e) => {
                                                handleFieldChange("access", e.target.value)
                                                setErrorMessage({ ...errorMessage, access: '' });
                                            }}
                                            className={errorMessage.access ? styles.errorTextField : styles.textField}
                                            placeholder="Enter Access"
                                        />
                                        {errorMessage.access ? <Typography sx={{ color: "red", fontSize: "12px" }}>{errorMessage.access}</Typography> : ''}

                                </Grid>
                            </Grid>
                            <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                                <Grid xs={12} sm={3} item>
                                {CustomRequiredInputLabel("Date of Registration", true)}
                                    <CustomTextFeild
                                        fullWidth
                                        required
                                        onChange={(e) => {
                                            handleFieldChange("dateOfRegistration", e.target.value);
                                            setErrorMessage({ ...errorMessage, dateOfRegistration: '' })
                                        }}
                                        className={errorMessage.dateOfRegistration ? styles.errorTextField : styles.textField}
                                        placeholder="Enter date"
                                    />
                                    {errorMessage.dateOfRegistration ? <Typography sx={{ color: "red", fontSize: "12px" }}>{errorMessage.dateOfRegistration}</Typography> : ''}
                                </Grid>
                                <Grid xs={12} sm={3} item>
                                {CustomRequiredInputLabel("Update Date", true)}
                                    <CustomTextFeild
                                        fullWidth
                                        required
                                        onChange={(e:ChangeEvent<HTMLInputElement>) => {
                                            handleFieldChange("updateDate", e.target.value);
                                            setErrorMessage({ ...errorMessage, updateDate: '' })
                                        }}
                                        className={errorMessage.updateDate ? styles.errorTextField : styles.textField}
                                    />
                                    {errorMessage.updateDate ? <Typography sx={{ color: "red", fontSize: "12px" }}>{errorMessage.updateDate}</Typography> : ''}
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} sx={{ marginTop: "0px" }}>
                                <Grid xs={12} sm={3} item>
                                {CustomRequiredInputLabel("Category", true)}
                                    {CategoryDropdown()}
                                </Grid>
                            </Grid>
                            <CommonButton sx={{ marginTop: "10px" }} onClick={handleAdd}>Add</CommonButton>
                        </div>

                        </Card>
                    </div>
                    <GridTableComponent tableData={ItemAddedData} columnMapping={columnMapping} />
                    <div style={{ paddingLeft: "24px" }}>
                        <CommonButton>Update</CommonButton>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Categories;
